import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {RadioButtonGroupInputComponent} from "./radio-button-group-input.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
    ],
    declarations: [
        RadioButtonGroupInputComponent,
    ],
    exports: [
        RadioButtonGroupInputComponent
    ],
})
export class RadioButtonGroupInputModule {}
